import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { CorpactCaAdminActionsTable } from '../../../../../../../../../../features/corporate-action/ca-admin/action/ca-admin-actions-table';
import { CorpactCaAdminActionCreateDrawer } from '../../../../../../../../../../features/corporate-action/ca-admin/action/ca-admin-create-manual-action-drawer';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/action/_action/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsCorporateActions,
      label: 'Actions',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsCorporateActions>,
  head: () => getPageHead('Corporate Action'),
  component: CorporateActionsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack align="end" blockAlign="center" gap={2}>
          <RequiresAccess write>
            <CorpactCaAdminActionCreateDrawer
              trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Corporate Action" size="small" />}
            />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsCorporateActions}
    />
  );
}

function CorporateActionsList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <CorpactCaAdminActionsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
